import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { UserService } from "../../../shared/services/user.service";
import { CommonService } from "../../../shared/services/common.service";
import { environment } from "../../../../environments/environment";
import { ToastrService } from "ngx-toastr";
import {
  Router,
  NavigationEnd,
  Event,
  NavigationStart,
  NavigationError,
  RoutesRecognized,
} from "@angular/router";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "app-profile",
  templateUrl: "./profile.component.html",
  styleUrls: ["./profile.component.scss"],
})
export class ProfileComponent implements OnInit {
  userLogedIn: boolean = false;
  currentUser: any;
  user_img = "";
  existImg: boolean = false;
  usre_id: any;
  user_name = "";
  // last_name = "";
  email = "";
  brief = "";
  mobile = "";
  address = "";
  password = "";
  confirmPassword = "";
  public errorOccurred = false;
  public errorOccurredMessage = "";
  page_name =
    localStorage.getItem("front-lang") == "ar" ? "حسابي" : "My Profile";
  successMobile: boolean = false;
  successUser_name: boolean = false;
  // successLast_name: boolean = false;
  successEmail: boolean = false;
  public openDashboard: boolean = false;
  public errorSuccessEmailMessage = "";

  public errorUserNameMessage = "";
  public errorLastNameMessage = "";

  errorMobileMessage = "";
  successPassword: boolean = false;
  successconfirmPassword: boolean = false;
  errorPasswordMessage = "";
  errorconfirmPasswordMessage = "";
  mobilePattern = /^\d{9,}$/;
  currentUrl: string = "";
  hostName: string = "";
  constructor(
    private toastrService: ToastrService,
    private user: UserService,
    private coomenservice: CommonService,
    private router: Router,
    private translateService: TranslateService
  ) {
    // SET TITLE
    this.coomenservice.setTitle(this.page_name);
  }

  ngOnInit(): void {
    this.checkOuth();
    this.hostName = this.coomenservice.getDomainFromUrl();
    this.currentUrl = `https://${this.hostName}/pages/profile`;
  }

  checkOuth() {
    if (this.user.getToken() !== null) {
      this.userLogedIn = true;
      this.currentUser = JSON.parse(this.user.getCurrentUser());
      this.usre_id = this.currentUser.id;
      this.user_img = this.currentUser.img;
      this.existImg =
        this.user_img != "" && this.user_img != null ? true : false;
      this.user_name = this.currentUser.user_name;
      // this.last_name = this.currentUser.last_name || "";
      this.email = this.currentUser.email;
      this.brief = this.currentUser.brief;
      this.address = this.currentUser.address;
      this.mobile = this.currentUser.mobile;
    } else {
      this.userLogedIn = false;
      this.currentUser = null;
      this.usre_id = "";
      this.existImg = false;
      this.user_img = "";
      // this.router.navigate(["/pages/login"]);
      this.goToLogin();
    }
  }
  userLogOut() {
    localStorage.removeItem("currentUserFront");
    localStorage.removeItem("clientToken");
    this.userLogedIn = false;
    this.currentUser = [];
    this.usre_id = "";
    this.user_img = "";
    this.user.logout();
    this.coomenservice.UpdatedSetting.next("logout");
    this.router.navigate(["/"]).then(() => {
      window.location.reload();
    });
  }
  ToggleDashboard() {
    this.openDashboard = !this.openDashboard;
  }

  userEditProfile() {
    this.errorOccurred = false;
    this.errorOccurredMessage = "";
    this.successUser_name = false;
    // this.successLast_name = false;
    this.successEmail = false;
    this.successPassword = false;
    this.successconfirmPassword = false;
    this.successMobile = false;

    if (this.password != this.confirmPassword) {
      this.errorOccurred = true;
      this.successconfirmPassword = true;
      this.translateService
        .get("Password Not Match")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
        });
    }

    // if (this.email != "") {
    //   if (this.coomenservice.validateEmail(this.email) == false) {
    //     this.errorOccurred = true;
    //     this.successEmail = true;
    //     this.translateService
    //       .get("valid mail")
    //       .subscribe((translatedMessage: any) => {
    //         this.errorOccurredMessage = translatedMessage;
    //       });
    //   }
    // } else {
    //   this.errorOccurred = false;
    //   this.successEmail = false;
    //   this.errorOccurredMessage = "";
    // }
    if (this.mobile == "" || !this.mobilePattern.test(this.mobile)) {
      this.successMobile = true;
      this.errorOccurred = true;
      this.translateService
        .get("valid mobile")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
        });
    }
    // if (this.last_name == "" || this.last_name.length < 3) {
    //   this.successLast_name = true;
    //   this.errorOccurred = true;
    //   this.translateService
    //     .get("last name message")
    //     .subscribe((translatedMessage: any) => {
    //       this.errorOccurredMessage = translatedMessage;
    //     });
    // }
    if (this.user_name == "" || this.user_name.length < 3) {
      this.successUser_name = true;
      this.errorOccurred = true;
      this.translateService
        .get("first name message")
        .subscribe((translatedMessage: any) => {
          this.errorOccurredMessage = translatedMessage;
        });
    }

    if (
      this.successUser_name === true ||
      // this.successLast_name === true ||
      this.successMobile === true ||
      // this.successEmail === true ||
      this.successconfirmPassword === true
    ) {
      return;
    } else {
      let body = {
        user_name: this.user_name,
        // last_name: this.last_name,
        mobile: this.mobile,
        email: this.email,
        password: this.password,
        brief: this.brief,
        address: this.address,
      };

      this.user.userEditProfile(body).subscribe((data) => {
        if (data.data) {
          if (localStorage.getItem("front-lang") == "en") {
            this.toastrService.success("Profile has been updated.");
          } else {
            this.toastrService.success("تم تحديث الملف الشخصي   ");
          }

          localStorage.setItem("clientToken", data.data.authentication_code);
          localStorage.setItem("affiliatorToken", environment.affiliator_token);
          localStorage.setItem("currentUserFront", JSON.stringify(data.data));

          this.user.userLoggedIn(data.data.user_name);

          if (
            localStorage.getItem("previousUrl") !== "" &&
            localStorage.getItem("previousUrl") != null &&
            localStorage.getItem("previousUrl") != "/pages/my-account"
          ) {
            this.router.navigate([localStorage.getItem("previousUrl")]);
          } else {
            this.router.navigate(["/pages/dashboard"]);
          }
        } else {
          this.errorOccurred = false;
          this.errorOccurredMessage = "";
          this.successUser_name = false;
          // this.successLast_name = false;
          this.errorUserNameMessage = "";
          this.errorLastNameMessage = "";
          this.successEmail = false;
          this.errorSuccessEmailMessage = "";
          this.successPassword = false;
          this.successconfirmPassword = false;
          this.errorconfirmPasswordMessage = "";
          this.successMobile = false;
          this.errorMobileMessage = "";
          if (data.errors) {
            this.errorOccurred = true;
            this.errorOccurredMessage = data.message;
          }
          if (data.errors["user_name"]) {
            this.successUser_name = true;
            this.errorUserNameMessage = data.errors["user_name"];
          }
          // if (data.errors["last_name"]) {
          //   this.successUser_name = true;
          //   this.errorLastNameMessage = data.errors["last_name"];
          // }
          if (data.errors["email"]) {
            this.successEmail = true;
            this.errorSuccessEmailMessage = data.errors["email"];
          }
          if (data.errors["password"]) {
            this.successPassword = true;
            this.errorPasswordMessage = data.errors["password"];
          }
          if (data.errors["mobile"]) {
            this.successMobile = true;
            this.errorMobileMessage = data.errors["mobile"];
          }
          return;
        }
      });
    }
  }

  loginclicked: boolean = false;

  // goToLogin() {
  //   this.loginclicked = true;
  // }
  // close() {
  //   this.loginclicked = false;
  // }
  step5Reached: boolean = false;
  stepSuccessReached: boolean = false;
  timeoutId: any;

  @ViewChild("login") loginSection;
  @ViewChild("loginFast") loginFast;

  goToLogin() {
    this.loginclicked = true;
  }

  close() {
    this.loginclicked = false;
    this.step5Reached = false;
    this.clearTimeout();
    if (this.stepSuccessReached) {
      window.location.reload();
    }
  }

  onStep5Reached() {
    this.step5Reached = true;
    this.startTimeout();
  }
  onstepSuccessReached() {
    this.stepSuccessReached = true;
  }

  startTimeout() {
    this.timeoutId = setTimeout(() => {
      this.close();
    }, 2000);
  }

  clearTimeout() {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
    }
  }
  @HostListener("document:click", ["$event"])
  onDocumentClick(event: MouseEvent) {
    if (!this.loginFast || !this.loginSection) {
      return;
    }
    const clickedInside = this.loginFast.nativeElement.contains(event.target);
    const clickedButton = this.loginSection.nativeElement.contains(
      event.target
    );

    if (clickedInside && this.loginclicked) {
      if (this.step5Reached) {
        this.close();
      }
    } else if (!clickedInside && clickedButton && this.loginclicked) {
      this.close();
    }
  }
}
